import { useBrandReportOptionsQuery } from "@src/__generated__/urql-graphql";
import { useEffect } from "react";
import type { BrandReportStore } from "./store";

export const useFetchTableOptions = (store: BrandReportStore) => {
  const [{ fetching: fetchingOptions, data: optionsData }] =
    useBrandReportOptionsQuery();

  useEffect(() => {
    if (!optionsData) return;
    store.setTableOptions(optionsData);
  }, [optionsData]);

  return fetchingOptions;
};
